import { create } from "zustand";
import { devtools } from "zustand/middleware";

/**
 * 다회사 컨텍스트 전역 상태 (클라이언트 전용 — UI 참조용).
 *
 * - companies: /auth/me 의 소속 회사 목록(회사 스위처).
 * - activeCompanyId: 현재 활성 회사. 실제 요청 헤더(X-Company-Id) 주입은 api-client(setActiveCompany)가 단일 소유.
 *   여기는 UI(스위처 하이라이트) 참조용이며, 신뢰 경계는 서버(멤버십 검증).
 */
export interface CompanyMembership {
  companyId: string;
  companyName: string;
  roleId: string;
  roleName: string;
  /** 그 회사에서의 역할 코드(roles.code) — 사용자 역할이면 null */
  roleCode?: string | null;
  isDefault: boolean;
}

interface CompanyStore {
  companies: CompanyMembership[];
  activeCompanyId: string | null;
  /**
   * 회사 생성 모달 열림 상태. 트리거(사용자 메뉴 항목)와 모달 렌더 위치가 분리돼 있으므로(모달은 Menu 밖에서 렌더 —
   * 메뉴 언마운트에도 살아남게) 스토어로 상태를 공유함.
   */
  createModalOpen: boolean;
  setCompanies: (companies: CompanyMembership[]) => void;
  setActiveCompanyId: (companyId: string | null) => void;
  setCreateModalOpen: (open: boolean) => void;
}

export const useCompanyStore = create<CompanyStore>()(
  devtools(
    (set) => ({
      companies: [],
      activeCompanyId: null,
      createModalOpen: false,
      setCompanies: (companies) => set({ companies }, false, "setCompanies"),
      setActiveCompanyId: (activeCompanyId) =>
        set({ activeCompanyId }, false, "setActiveCompanyId"),
      setCreateModalOpen: (createModalOpen) =>
        set({ createModalOpen }, false, "setCreateModalOpen"),
    }),
    { name: "eqms/company" },
  ),
);
